(() => {
  const AI_MARKER = '[[AI]]';
  const AI_LABEL = 'KI-generierte Darstellung';

  const imageStates = new WeakMap();

  function cleanAltText(alt) {
    return alt
      .replace(/\[\[AI\]\]/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function getImageHost(image) {
    let host = image.parentElement;

    if (!host) return null;

    /*
     * Bilder können innerhalb eines <picture>-Elements liegen.
     * In diesem Fall verwenden wir dessen übergeordneten Container,
     * damit das Athens-Layout nicht verändert wird.
     */
    if (host.tagName === 'PICTURE' && host.parentElement) {
      host = host.parentElement;
    }

    return host;
  }

  function createBadge(image) {
    const existingState = imageStates.get(image);

    if (
      existingState &&
      existingState.badge &&
      existingState.badge.isConnected
    ) {
      return;
    }

    const host = getImageHost(image);

    if (!host) return;

    /*
     * Vorhandene Positionierung von Athens nicht überschreiben.
     */
    if (window.getComputedStyle(host).position === 'static') {
      host.classList.add('rv-ai-host--positioned');
    }

    let badge = host.querySelector(':scope > .rv-ai-badge');

    if (!badge) {
      badge = document.createElement('span');

      badge.className = 'rv-ai-badge';
      badge.textContent = 'AI';

      badge.setAttribute('role', 'img');
      badge.setAttribute('aria-label', AI_LABEL);
      badge.setAttribute('title', AI_LABEL);

      host.appendChild(badge);
    }

    imageStates.set(image, {
      host: host,
      badge: badge
    });
  }

  function removeBadge(image) {
    const state = imageStates.get(image);

    delete image.dataset.rvAi;
    delete image.dataset.rvAiCleanAlt;

    if (!state) return;

    const host = state.host;

    /*
     * Nur entfernen, wenn im gleichen Bildcontainer
     * kein weiteres gekennzeichnetes Bild vorhanden ist.
     */
    const anotherAiImage = host
      ? host.querySelector('img[data-rv-ai="true"]')
      : null;

    if (!anotherAiImage) {
      if (state.badge && state.badge.isConnected) {
        state.badge.remove();
      }

      if (host) {
        host.classList.remove('rv-ai-host--positioned');
      }
    }

    imageStates.delete(image);
  }

  function processImage(image) {
    if (!(image instanceof HTMLImageElement)) return;

    const alt = image.getAttribute('alt') || '';

    /*
     * Neues, noch nicht verarbeitetes AI-Bild
     */
    if (alt.toUpperCase().includes(AI_MARKER)) {
      const cleanAlt = cleanAltText(alt);

      image.dataset.rvAi = 'true';
      image.dataset.rvAiCleanAlt = cleanAlt;

      /*
       * [[AI]] darf nicht im SEO-/Accessibility-Alt-Text
       * auf der fertigen Seite stehen.
       */
      if (alt !== cleanAlt) {
        image.setAttribute('alt', cleanAlt);
      }

      createBadge(image);

      return;
    }

    /*
     * Bereits von uns verarbeitetes Bild
     */
    if (image.dataset.rvAi === 'true') {
      const expectedAlt = image.dataset.rvAiCleanAlt || '';

      if (alt === expectedAlt) {
        createBadge(image);
      } else {
        /*
         * Athens hat vermutlich dynamisch auf ein anderes
         * Bild bzw. Medium gewechselt.
         */
        removeBadge(image);
      }
    }
  }

  function scanImages(root = document) {
    if (root instanceof HTMLImageElement) {
      processImage(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('img').forEach(processImage);
    }
  }

  function startAiLabels() {
    /*
     * Bereits vorhandene Bilder prüfen.
     */
    scanImages(document);

    /*
     * Athens lädt verschiedene Inhalte dynamisch nach:
     * Filter, AJAX-Seitenwechsel, Quick View, Lightbox,
     * Warenkorb usw.
     *
     * Deshalb überwachen wir neu eingefügte Bilder.
     */
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              scanImages(node);
            }
          });
        }

        if (
          mutation.type === 'attributes' &&
          mutation.target instanceof HTMLImageElement
        ) {
          processImage(mutation.target);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['alt']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startAiLabels,
      { once: true }
    );
  } else {
    startAiLabels();
  }
})();